<template>
  <div v-loading="loading">
    <div class="card-wrap">
      <template v-if="tableData.length>0">
        <dishonesty-list
          v-for="(item, index) in tableData"
          :key="index"
          :data="item"
        ></dishonesty-list>
        <div v-if="tableData.length===5" class="lookMore" @click="lookMore">查看更多&gt;</div>
      </template>
      <template v-else>
        <div class="card-empty">暂无数据</div>
      </template>
    </div>
  </div>
</template>

<script>
import utils from "@mixins/utils";
import DishonestyList from "../section/dishonesty-list";

export default {
  mixins: [utils],
  components: {
    DishonestyList
  },
  data() {
    return {
      title: "",
      loading: false,
      tableData: [], //标准规范
      pgData: {
        pageIndex: 1,
        pageSize: 5,
        qyname: "",
        zfdw: "",
        startcfdate: "",
        endcfdate: "",
      }
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$ajax({
        url: `${this.$store.state.api.webUrl}/dishonest/getdishonestpage.json`,
        data: this.pgData,
        callback: data => {
          this.tableData = data.rows
        },
        complete: () => {
          this.loading = false;
        }
      });
    },
    lookMore() {
      window.location.assign("/dishonestyRoster");
    },
  },
};
</script>

<style scoped lang="scss">
.card-wrap {
  border-radius: 8px;
  height: 360px;
}

.card-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-weight: 400;
  font-size: 14px;
  color: #aaa;
  text-align: center;
  padding-top: 20px;
}

.lookMore {
  margin-top: 10px;
  text-align: center;
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}
</style>

